import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  setCustomerModalOpen,
  setCustomerPage,
  get_customer_list,
  create_customer,
  update_customer,
  setAction,
  setId,
  setStatus,
  setSearchQuery,
  activate_deactivate_customer,
  get_customer_details
} from "../../../store/customer/customerSlice";

const mapStateToProps = (state) => {
  const {
    is_customer_modal_open,
    customer_list,
    common_loading,
    total_customer_count,
    active_customer,
    page,
    c_action,
    customer_id,
    selected_status,
    search_query,
    selected_data
  } = state.customer;

  return {
    is_customer_modal_open: is_customer_modal_open,
    customer_list: customer_list,
    total_customer_count: total_customer_count,
    common_loading: common_loading,
    active_customer: active_customer,
    page: page,
    c_action: c_action,
    customer_id: customer_id,
    selected_status: selected_status,
    search_query: search_query,
    selected_data: selected_data
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({
    setCustomerModalOpen,
    setCustomerPage,
    get_customer_list,
    create_customer,
    update_customer,
    setAction,
    setId,
    setStatus,
    setSearchQuery,
    activate_deactivate_customer,
    get_customer_details
  }, dispatch);

const Store = (Container) =>
  connect(mapStateToProps, mapDispatchToProps)(Container);

export default Store;
